import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { getCommonDropdownList } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { formatToCorrectDate } from '../../../../SharedModules/DateUtilities/DateUtilities';
import moment from 'moment';

export const dispatchGetAllIneligibleProvider = (data) => ({
  type: actionTypes.GET_ALL_INELIGIBLLE_PROVIDER_DATA,
  ineligibleProviderData: data,
});
export const dispatchViewHistoryforPlan = (values) => {
  return {
    planViewHistory: values,

    type: actionTypes.VIEW_HISTORY,
  };
};
export const setNewTBillRow = (payload) => {
  return {
    type: actionTypes.ADD_NEW_TBILL_DATA,
    payload,
  };
};
export const setUpdateIneligiblePrvRes = (payload) => {
  return {
    type: actionTypes.INELIGIBLE_PROV_RES,
    payload,
  };
};

export const addNewRowData = (payload) => {
  return (dispatch, getState) => {
    const dataList = [...getState().sharedState.TBillTableReducer.allTBillList];
    if (Array.isArray(payload) && payload && payload.length > 0) {
      dispatch(setNewTBillRow(payload));
    } else {
      const temp = [...dataList];
      temp.unshift(payload);
      dispatch(setNewTBillRow(temp.concat(payload)));
    }
  };
};

export const getAllIneligibleProvider =
  (setCommonDropdownList) => (dispatch) => {
    return axios
      .get(serviceEndPoint.GET_INELIGIBLE_PROVIDER_DETAILS, {
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        },
      })
      .then((response) => {
        const newObj =
          response.data?.data?.map((item) => {
            return {
              tempId: uuidv4(),
              providerId: item?.ineligProviderIdVO?.providerId,
              providerIdTypeCd: item?.ineligProviderIdVO?.providerIdTypeCd,
              ineligProviderBeginDt:
                item?.ineligProviderIdVO?.ineligProviderBeginDt,
              endDt: item?.endDt,
              lastUpdateDt: item?.lastUpdateDt,
              lastUpdateUserId: item?.lastUpdateUserId,
              providerName: item?.providerName,
              isFromAPI: true,
              oldIneligProviderBeginDt: item?.ineligProviderIdVO
                ?.ineligProviderBeginDt
                ? item?.ineligProviderIdVO?.ineligProviderBeginDt
                : null,
              oldEndDt: item?.endDt ? item?.endDt : null,
            };
          }) || [];

        return getCommonDropdownList({
          codeDomainList: ['PROVIDER_ID_TYPE_CD'],
        }).then((res) => {
          let dataWithDropdown = newObj;
          if (newObj.length > 0) {
            dataWithDropdown = newObj.map((item) => {
              const firstDropdownVal = res?.PROVIDER_ID_TYPE_CD?.filter((x) => {
                return (
                  x.codeValueID &&
                  x.codeValueID?.codeValue === item.providerIdTypeCd
                );
              });
              if (firstDropdownVal && firstDropdownVal.length > 0) {
                item.providerIdTypeName =
                  firstDropdownVal[0].shortDescription;
              }
              return item;
            });
          }
          dispatch(
            dispatchGetAllIneligibleProvider({
              ...response.data,
              data: dataWithDropdown,
            })
          );
        });
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.status == 401) return;
        dispatch(dispatchGetAllIneligibleProvider({ error: 'API failed' }));
      });
  };

export const updateIneligibleProvider = (values) => (dispatch) => {
  return axios
    .post(
      serviceEndPoint.UPDATE_INELIGIBLE_PROVIDER,
      values?.map((item) => {
        if (item.tempId) delete item.tempId;
        return item;
      })
    )
    .then((response) => {
      if (response.status === '200') {
        dispatch(setUpdateIneligiblePrvRes('SUCCESS'));
      }
      return response.data;
    })
    .catch((error) => {
      dispatch(setUpdateIneligiblePrvRes('failed'));
      return error;
    });
};

export const setErrorMessages = (payload) => {
  return {
    type: actionTypes.HANDLE_ERROR_MESSAGE_MIP,
    payload,
  };
};

export const setGridData = (payload) => {
  return {
    type: actionTypes.SET_GRID_DATA,
    payload,
  };
};

export const setEditedData = (payload) => {
  return {
    type: actionTypes.SET_EDITED_DATA,
    payload,
  };
};

export const resetIneligibleProviderStore = () => {
  return {
    type: actionTypes.RESET_INELIGIBLE_PROVIDERS_STORE,
  };
};

export const updateIneligibleProviderAndFetch =
  (values) => async (dispatch, getState) => {
    const currentGrid = getState().sharedState.IneligibleProvidersReducer.gridData || []
    const updatedGrid = gridCopy(currentGrid)
      try {
      const response = await axios.post(
        serviceEndPoint.UPDATE_INELIGIBLE_PROVIDER,
        values?.map((item) => {
          if (item.tempId) delete item.tempId;
          return item;
        })
      );
      console.log("res",response)
      if (response.status === 200) {
        dispatch(setUpdateIneligiblePrvRes('SUCCESS'));
        dispatch(setEditedData([]));
        dispatch(setDeletedData([]))
        dispatch(setNewProviderData([]))
        dispatch(setGridData(updatedGrid))
        dispatch(dispatchGetAllIneligibleProvider(mapTopGridProviderData(updatedGrid)))
        return 'SUCESS';
      }
      dispatch(setUpdateIneligiblePrvRes('failed'));
      return response.data;
    } catch (error) {
      dispatch(setUpdateIneligiblePrvRes('failed'));
      return error;
    }
  };
 
export const validateIneligibleProvider = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.VALIDATE_INELIGIBLE_PROVIDER, values)
    .then((response) => {
      if (response.status === '200') {
        dispatch(setUpdateIneligiblePrvRes('SUCCESS'));
      }
      return response.data;
    })
    .catch((error) => {
      dispatch(setUpdateIneligiblePrvRes('failed'));
      return error;
    });
};

export const setDeletedData = (payload) => {
  return {
    type: actionTypes.SET_DELETED_DATA,
    payload,
  };
};

export const setNewProviderData = (payload) => {
  return {
    type: actionTypes.SET_NEW_PROVIDER_DATA,
    payload,
  };
};
export const ClearReduxDataIneligibleProviderScr = (payload) => {
  return {
    type: actionTypes.CLEAR_REDUX_DATA_INELIGIBLE_PROVIDER,
    payload,
  };
};
export const gridCopy = (currentGrid) =>{
  const normalizeDate = (val) => (val ? moment(val).format('MM/DD/YYYY') : val);
 
  return (currentGrid || [])
    .filter((row) => !row.deleteRecord)
    .map((row) => {
      const beginVal = normalizeDate(row.ineligProviderBeginDt);
      const endVal = row.endDt ? normalizeDate(row.endDt) : row.endDt;
      return {
        ...row,
        ineligProviderBeginDt: beginVal,
        endDt: endVal,
        oldIneligProviderBeginDt: beginVal,
        oldEndDt: endVal,
        isFromAPI: true,
        newRecord: false,
        updateRecord: false,
        deleteRecord: false,
        addEditRow: false,
        isUpdateIneligProviderBeginDt: false,
        isUpdateEndDt: false,
        ineligProviderBeginDtErr: false,
        endDtErr: false,
      };
    });
};
export const mapTopGridProviderData =(grid)=>( {
  message:'SUCESS',
  status : '001',
  data : gridCopy(grid),
}) 

export const resetIneligibleProviderTab = ()=>({
  type:actionTypes.CLEAR_REDUX_DATA_INELIGIBLE_PROVIDER
})